import { render, staticRenderFns } from "./contractAssignDetail.vue?vue&type=template&id=5473749b&scoped=true"
import script from "./contractAssignDetail.vue?vue&type=script&lang=js"
export * from "./contractAssignDetail.vue?vue&type=script&lang=js"
import style0 from "./contractAssignDetail.vue?vue&type=style&index=0&id=5473749b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5473749b",
  null
  
)

export default component.exports